import { ListKeysType, TagsDto } from "src/app/shared/dto";
import { RodStatusEnum } from "src/app/shared/enums/rod-statuses.enum";

export class SavedSearchesModel {
    contactCount: number;
    companyCount: number;
    totalRecords: number;
}

export class ListsModel {
    companiesCount: number;
    contactCount: number;
    suppressionCount: number;
    totalRecords: number;
}

export interface FilterSavedSearchesInterface {
    searchName: string,
    public: boolean,
    tags: number[]
};

export const FilterSavedSearches: FilterSavedSearchesInterface = {
    searchName: '',
    public: true,
    tags: []
};

export const ListTypes: Record<ListKeysType, string> = {
    'Companies': 'Company List',
    'Contacts': 'Contact List',
    'Suppression': 'Suppression List'
};

export const FilterLists = {
    name: '',
    team: true,
    selectedTypes: Object.keys(ListTypes),
    tags: []
};

export const FilterRoDs = {
    subject: '',
    selectedStatuses: Object.values(RodStatusEnum)
};
